import React from 'react'

export default function Loader() {
  return (
    <div className='loader-section'>
        <div className="loader"></div>
    </div>
  )
}
